import { createSelector } from '@reduxjs/toolkit';
import jwt_decode from 'jwt-decode';

import { IStore2, ITip, IToken, TipScreenTypes } from 'types';

const tokenSelector = (state: IStore2) => state.user.token;

const shopSelector = (state: IStore2) => state.shop.details;

const tipsSelector = (state: IStore2) => state.config.tips;

const isShopOwner = createSelector([tokenSelector, shopSelector], (token, shop) => {
  if (!token || !shop) {
    return false;
  }

  const parsedToken = jwt_decode<IToken>(token);

  const { userId: loggedInUserId } = parsedToken;

  const { ownersIds } = shop;

  const isOwner = ownersIds.find((userId) => userId === loggedInUserId);

  return !!isOwner;
});

const shopTipSelector = createSelector([tipsSelector], (tips): ITip | null => {
  return tips.find((tip) => tip.displayedRoutes.includes(TipScreenTypes.Shop)) || null;
});

export const ShopSelector = {
  isShopOwner,
  tokenSelector,
  shopTipSelector,
};
